export const OPERATORS = {
  IS: "=",
  IS_NOT: "!=",
  LESS_THAN: "<",
  LESS_THAN_OR_EQUAL: "<=",
  GREATER_THAN: ">",
  GREATER_THAN_OR_EQUAL: ">=",
  CONTAINS: "contains",
  DOES_NOT_CONTAIN: "doesNotContain",
  BETWEEN: "between",
};
